module.exports = __webpack_public_path__ + "static/media/let11.0e54a478.JPG";